import React from 'react';

/** @import {PendingAccountProps} from './PendingAccountTypes' */

import './account.scss';

function PendingAccount (/** @type {PendingAccountProps} */ props) {
    const { account } = props;

    return (
        <div className='pending-account__container'>
            <div className='pending-account__left'>
                <div className='pending-account__account-detail'>
                    {account.productName} {account.issueNumber && `Issue ${account.issueNumber}`}
                </div>
            </div>
            <div className='pending-account__right'>
                <div className='pending-account__title'>
                    We are opening your account
                </div>
                <div className='pending-account__detail'>
                    You'll see it here and be able to make your first deposit when it's ready.
                </div>
            </div>
        </div>
    );
}

export default PendingAccount;
